export enum MarketplaceType {
  DRAW = 'DRAW',
  AUCTION = 'AUCTION',
  PURCHASE = 'PURCHASE',
  PURCHASE_DYNAMIC_PRICE = 'PURCHASE_DYNAMIC_PRICE',
  SECONDARY_EXCHANGE = 'SECONDARY_EXCHANGE',
  PROMOTER = 'PROMOTER',
  CLIENT_GUEST = 'CLIENT_GUEST',
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/model/marketplace-type.ts